import { IColuna } from "app/types/IColuna";
import { IOrcamento } from "app/types/IOrcamento";
import { Parametro } from "app/types/Parametro";
import * as R from 'ramda'
import { obterColunasEstoquesFiliais } from "./obterColunasEstoquesFiliais";
import { tipoOrcamentoSuportaMostruario } from "app/use-cases/orcamento/tipoOrcamentoSuportaMostruario";
import { props } from "app/components/senha-vendedor/SenhaVendedor.stories";
import { PinDropSharp } from "@mui/icons-material";

export type ObterColunasParams = {
    colunasDoCadastroDoUsuario: IColuna[]
    parametros: Parametro[]
    parametrosPorFilial: Parametro[]
    permissaoOrcamentoItemVenda: boolean
    permissaoAcaoMostrarLocalRetirada: boolean
    orcamento: IOrcamento


}

const ordemColunas = [
    "OrdemItem","Codigo","Referencia","Descricao","Unidade","Quantidade","QuantidadeSolicitada","QuantidadePendente","PrecoUnitario","PorcentagemDescontoUnitario","PreservarDescontoUnitario","PrecoTotal",
    "PrecoSolTotal","PrecoPendenciaTotal", "PercentualMarkUp","DespesasInclusas","DescricaoTipoEntrega", "EstoqueTotal",
    "FilialRetirada", "FilialTransferencia", "TipoFaturamento", // nao separar essas 3 colunas
    "ServicoAgregado",
    "DataPrevisaoEntrega","DataMarcadaEntrega", // nao separa essas 2 colunas
    "ValorSubstituicao","DescricaoTurnoEntrega",
    "VendaSobEncomenda","EncomendaExpressa", // 433263 nao separa essas 2 colunas
    "EntregaPosterior",
    "Mostruário", // PA 487087
    "AliquotaIPI","ValorIPI","Classe", "Ambiente","PercentualDesconto","PercentualBonificacao",
    "PrioridadeMontagem", //4556839
    "CentroDeCusto",
    "SistemaTintometrico",
    "Cor","ModeloProduto","PedidoCompra","LinhaOrdemCompra", 
    "Observacao", 
    "Acoes"
]

export const compararColunas = (c1: IColuna, c2: IColuna, codigoFilialOrcamento: string, parametro_CHAVE_MOVIMENTACAO_ORCAMENTO: "C" | "R" ) => {

    const colunasSaoDeEstoqueDeFiliais = () => {
        const r = /F[0-9]{2}/

        return r.test(c1.Nome) && r.test(c2.Nome)
    }

    const compararColunasEstoqueFiliais = () => {
        return  c1.Nome == `F${codigoFilialOrcamento}` ? -1 :
                c2.Nome == `F${codigoFilialOrcamento}` ?  1 :
                c1.Nome.localeCompare(c2.Nome)
    }

    const compararColunasNormais = () => {

        const tratarComBaseNasOrdensFixas = () => {
            const posicaoC1 =   c1.ehEstoqueFilial ? ordemColunas.findIndex(c => c == "PercentualMarkUp") :
            ordemColunas.findIndex(nomeColuna => nomeColuna == c1.Nome)

            const posicaoC2 =   c2.ehEstoqueFilial ? ordemColunas.findIndex(c => c == "PercentualMarkUp") :
                        ordemColunas.findIndex(nomeColuna => nomeColuna == c2.Nome)


            const c1Existe = () => posicaoC1 != -1
            const c2Existe = () => posicaoC2 != -1

            return  c1Existe() && !c2Existe() ? -1 :
            !c1Existe() && c2Existe() ? 1 :
            c1Existe() && c2Existe() ? posicaoC1 - posicaoC2 :
            0
        }

        const tratarOrdemCodigoReferenciaDescricao = () => {
            const ordem = parametro_CHAVE_MOVIMENTACAO_ORCAMENTO == "C" ? ["Codigo", "Descricao", "Referencia"] : ["Referencia", "Descricao","Codigo"]

            const posicaoC1 = ordem.findIndex(nomeColuna => nomeColuna == c1.Nome)
            const posicaoC2 = ordem.findIndex(nomeColuna => nomeColuna == c2.Nome)

            return posicaoC1 - posicaoC2


        }

        return  ["Codigo","Referencia", "Descricao"].includes(c1.Nome) &&
                ["Codigo","Referencia", "Descricao"].includes(c2.Nome) ? tratarOrdemCodigoReferenciaDescricao() : tratarComBaseNasOrdensFixas()


    }

    return colunasSaoDeEstoqueDeFiliais() ? compararColunasEstoqueFiliais() : compararColunasNormais()


}

function colunaCadastroUsuarioDeveSerExibida(coluna: IColuna) : boolean {
    const colunasParaNaoExibir = ["preço Unitario","Quant", "Info"]
    const colunaEhDeEstoqueDeFilial = () => /F[0-9]{2}/.test(coluna.Nome)

    return !R.includes(coluna.Nome, colunasParaNaoExibir) && !colunaEhDeEstoqueDeFilial()
}

export function obterColunas(params: ObterColunasParams) : IColuna[] {
    const colunas_ = [
        ...params.colunasDoCadastroDoUsuario.filter(colunaCadastroUsuarioDeveSerExibida),
        ...obterColunasEstoquesFiliais(params.orcamento).filter(c => c.Permitido != false),
    ]


    const colunasOrdenadas = R.sort((c1,c2) => compararColunas(c1,c2,
            params.orcamento.CodigoFilialOrcamento,
            params.parametros.find(p => p.Nome == "CHAVE_MOVIMENTACAO_ORCAMENTO")?.Valor as "C" | "R"), colunas_)


    const handleColuna: {[nomeColuna:string] : () => boolean} = {}

    colunasOrdenadas.forEach(c => handleColuna[c.Nome] = R.T)

    const colunaPermitida = (nome:string) => {
    const coluna = params.colunasDoCadastroDoUsuario.find(c => c.Nome == nome)
        return  coluna == null ? true :
                coluna.Permitido
    }

    handleColuna["Codigo"] = () => colunaPermitida('Codigo')

    handleColuna["Referencia"] = () => colunaPermitida('Referencia')

    handleColuna['OrdemItem'] = () => {
        return colunaPermitida('OrdemItem') && (params.permissaoOrcamentoItemVenda ?? false);
    }
    
    handleColuna['QuantidadeSolicitada'] = () => {
        return colunaPermitida('QuantidadeSolicitada') && params.parametros.find(p => p.Nome == 'EXIBIR_QUANTIDADE_PENDENTE_ORCAMENTO')?.Valor == "S";
    }

    handleColuna['PrecoSolTotal'] = () => {
        return colunaPermitida('PrecoSolTotal') && params.parametros.find(p => p.Nome == 'EXIBIR_QUANTIDADE_PENDENTE_ORCAMENTO')?.Valor == "S";
    }

    handleColuna['QuantidadePendente'] = () => {
        return colunaPermitida('QuantidadePendente') && params.parametros.find(p => p.Nome == 'EXIBIR_QUANTIDADE_PENDENTE_ORCAMENTO')?.Valor == "S" &&
            params.parametros.find(p => p.Nome == 'ACEITAR_PRODUTO_SEM_ESTOQUE')?.Valor == "S";
    }

    handleColuna['EstoqueTotal'] = () => {
        return colunaPermitida('EstoqueTotal') && params.parametros.find(p => p.Nome == 'EXIBIR_COLUNA_ESTOQUE_TOTAL_PRODUTO_VENDAS')?.Valor == "S" ;
    }

    handleColuna['PrecoPendenciaTotal'] = () => {
        return colunaPermitida('PrecoPendenciaTotal') && params.parametros.find(p => p.Nome == 'EXIBIR_QUANTIDADE_PENDENTE_ORCAMENTO')?.Valor == "S" &&
            params.parametros.find(p => p.Nome == 'ACEITAR_PRODUTO_SEM_ESTOQUE')?.Valor == "S";
    }

    handleColuna['PercentualMarkUp'] = () => {
        return colunaPermitida('PercentualMarkUp') && params.parametros.find( p => p.Nome == 'CUSTO_PARA_GERAR_MARKUP')?.Valor != "" && // == "28889" && // ficha 449225 -- 
                params.parametros.find(p => p.Nome == 'VISUALIZA_MARKUP_PRODUTO_ORCAMENTO')?.Valor == "S" // ficha 449225 &&
                // ficha 449225 params.parametros.find(p => p.Nome == 'DESABILITAR_PAGINA_ORDEM_SEPARACAO_CONFERENCIA_SAIDA')?.Valor == "S"
    }

    handleColuna['TipoFaturamento'] = () => {
        return colunaPermitida('FilialRetirada') &&  params.permissaoAcaoMostrarLocalRetirada &&
                (params.orcamento.TipoOrcamentoDescricao == "Venda" ||
                    (params.orcamento.TipoOrcamentoDescricao == "Outras Saídas" && params.parametros.find(p => p.Nome == "ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL")?.Valor == "S"))
    }

    handleColuna['FilialRetirada'] = () => {
        return colunaPermitida('FilialRetirada') &&  params.permissaoAcaoMostrarLocalRetirada &&
                (params.orcamento.TipoOrcamentoDescricao == "Venda" ||
                    (params.orcamento.TipoOrcamentoDescricao == "Outras Saídas" && params.parametros.find(p => p.Nome == "ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL")?.Valor == "S"))
    }

    handleColuna['FilialTransferencia'] = () => {
        return colunaPermitida('FilialTransferencia') &&  params.permissaoAcaoMostrarLocalRetirada &&
                (params.orcamento.TipoOrcamentoDescricao == "Venda" ||
                    (params.orcamento.TipoOrcamentoDescricao == "Outras Saídas" && params.parametros.find(p => p.Nome == "ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL")?.Valor == "S"))
    }

    handleColuna['ServicoAgregado'] = () => {
        return params.orcamento.TipoOrcamentoDescricao == "Venda"
            && colunaPermitida('ServicoAgregado') 
            &&  params.parametrosPorFilial.find(p => p.Nome == "UTILIZA_SERVICO_AGREGADO_ORCAMENTO")?.Valor == "S"
    }

    handleColuna['PrioridadeMontagem'] = () => { // 456839
        return params.orcamento.TipoOrcamentoDescricao == "Venda" // 456839
            && colunaPermitida('PrioridadeMontagem') 
            && params.parametrosPorFilial.find(p => p.Nome == "TRABALHA_ORDEM_CARGA_ORDEM_ENTREGA_MONTAGEM_CARGA_FATURAMENTO")?.Valor == "S"  // 456839
    }

    handleColuna['Mostruário'] = () => { // PA 487087
        return tipoOrcamentoSuportaMostruario(params.orcamento.TipoOrcamento)
            && colunaPermitida('Mostruário')
    }

    handleColuna['TipoFaturamento'] = () => {
        return colunaPermitida('TipoFaturamento') &&  params.permissaoAcaoMostrarLocalRetirada &&
                (params.orcamento.TipoOrcamentoDescricao == "Venda" ||
                    (params.orcamento.TipoOrcamentoDescricao == "Outras Saídas" && params.parametros.find(p => p.Nome == "ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL")?.Valor == "S"))
    }

    handleColuna['DataPrevisaoEntrega'] = () => {
        return colunaPermitida('DataPrevisaoEntrega') &&  params.parametros.find(p => p.Nome == 'DEFINIR_PREVISAO_ENTREGA_POR_ITEM')?.Valor == "S";
    }

    handleColuna['DataMarcadaEntrega'] = () => {
        return colunaPermitida('DataMarcadaEntrega') &&  params.parametros.find(p => p.Nome == 'DEFINIR_PREVISAO_ENTREGA_POR_ITEM')?.Valor == "S";
    }

    handleColuna['DescricaoTurnoEntrega'] = () => {
        return colunaPermitida('DescricaoTurnoEntrega') &&  params.parametros.find(p => p.Nome == 'DEFINIR_PREVISAO_ENTREGA_POR_ITEM')?.Valor == "S";
    }

    handleColuna['ValorSubstituicao'] = () => {
        return colunaPermitida('ValorSubstituicao') &&  colunaPermitida('ValorSubstituicao') &&  params.parametros.find(p => p.Nome == 'APURAR_ST_ORCAMENTO')?.Valor == "S";
    }
    
    handleColuna['VendaSobEncomenda'] = () => {
        const  parametroDefinirVendaSobEncomenda = params.parametros.find(p => p.Nome == 'TRATAR_VENDAS_SOB_ENCOMENDA')?.Valor;
        return colunaPermitida('VendaSobEncomenda') 
                        && params.orcamento.OidFornecedorPorRepresentacao <= 7 // 456252/468760                
                        && parametroDefinirVendaSobEncomenda != "0" 
                        && parametroDefinirVendaSobEncomenda != "" 
                        && parametroDefinirVendaSobEncomenda != null
    }

    handleColuna['EncomendaExpressa'] = () => { // 433263
        const  parametroDefinirVendaSobEncomenda = params.parametros.find(p => p.Nome == 'TRATAR_VENDAS_SOB_ENCOMENDA')?.Valor;
        return colunaPermitida('VendaSobEncomenda') 
                        && params.orcamento.OidFornecedorPorRepresentacao <= 7 // 456252/468760
                        && params.parametrosPorFilial.find(p => p.Nome == 'UTILIZA_RECURSO_ENCOMENDA_EXPRESSA')?.Valor == "S" 
                        && parametroDefinirVendaSobEncomenda != "0" 
                        && parametroDefinirVendaSobEncomenda != "" 
                        && parametroDefinirVendaSobEncomenda != null
    }

    handleColuna['EntregaPosterior'] = () => {
        return  colunaPermitida('EntregaPosterior') &&  params.parametros.find(p => p.Nome == 'VENDA_COM_ENTREGA_POSTERIOR_POR_ITEM')?.Valor == "S";
    }

    handleColuna['PreservarDescontoUnitario'] = () => {
        return colunaPermitida('PreservarDescontoUnitario') && params.parametros.find(p => p.Nome == 'PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO')?.Valor == "S";
    }

    handleColuna['PercentualBonificacao'] = () => {
        return colunaPermitida('PercentualDesconto') &&  params.parametrosPorFilial.find(p => p.Nome == 'ORCWEB_UTILIZA_DESCONTO_MAXIMO_BONIFICACAO_AVANCADOS')?.Valor == "S"
    }

    handleColuna['PercentualBonificacao'] = () => {
        return colunaPermitida('PercentualBonificacao') &&  params.parametrosPorFilial.find(p => p.Nome == 'ORCWEB_UTILIZA_DESCONTO_MAXIMO_BONIFICACAO_AVANCADOS')?.Valor == "S"
    }

    handleColuna['Ambiente'] = () => {
        const parametroAmbienteOrcamentoFilial = params.parametros.find(p => p.Nome == 'AMBIENTE_ORCAMENTO_POR_FILIAL')?.Valor;
        const parametroAmbienteOrcamento = params.parametros.find(p => p.Nome == 'AMBIENTE_ORCAMENTO')?.Valor;
        return colunaPermitida('Ambiente') &&  ((parametroAmbienteOrcamentoFilial ?? "") != "" ? parametroAmbienteOrcamentoFilial.includes("S") : parametroAmbienteOrcamento?.includes("S"))
    }

    handleColuna['Observacao'] = () => {
        return colunaPermitida('Observacao') &&  params.parametros.find(p => p.Nome == 'PERMITIR_OBSERVACAO_POR_ITEM')?.Valor == "S";
    }

    handleColuna['Info'] = () => colunaPermitida('Info')

    handleColuna["AliquotaIPI"] = () => colunaPermitida("AliquotaIPI")
    handleColuna["Unidade"] = () => colunaPermitida("Unidade")
    handleColuna["Acoes"] = () => colunaPermitida("Acoes")
    handleColuna["Descricao"] = () => colunaPermitida("Descricao")
    handleColuna["PrecoTotal"] = () => colunaPermitida("PrecoTotal")
    handleColuna["Classe"] = () => colunaPermitida("Classe")
    handleColuna["DespesasInclusas"] = () => colunaPermitida("DespesasInclusas")
    handleColuna["PrecoUnitario"] = () => colunaPermitida("PrecoUnitario")
    handleColuna["PorcentagemDescontoUnitario"] = () => colunaPermitida("PorcentagemDescontoUnitario")
    handleColuna["ValorIPI"] = () => colunaPermitida("ValorIPI")
    handleColuna["Codigo"] = () => colunaPermitida("Codigo")
    handleColuna["DescricaoTipoEntrega"] = () => colunaPermitida("DescricaoTipoEntrega")
    handleColuna["Quantidade"] = () => colunaPermitida("Quantidade")
    handleColuna["Cor"] = () => colunaPermitida("Cor")
    handleColuna["ModeloProduto"] = () => colunaPermitida("ModeloProduto")
    handleColuna["SistemaTintometrico"] = () => colunaPermitida("SistemaTintometrico")
    


    return colunasOrdenadas.filter(c => handleColuna[c.Nome]())
}
